export default function Marquee({ items, className = "", dark = false }) {
  const content = [...items, ...items];
  return (
    <div className={`relative w-full overflow-hidden ${className}`} data-testid="marquee">
      <div className="marquee-track">
        {content.map((item, i) => (
          <span key={i} className="inline-flex items-center">
            <span className={`font-display text-5xl md:text-7xl font-medium px-6 ${dark ? "text-paper" : "text-ink"}`}>
              {item}
            </span>
            <span className="text-gold text-3xl md:text-5xl px-2">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
